
import { Component, Vue, Prop } from 'vue-property-decorator'
import DataTable from './DataTable.vue'
import { TableGroupDefinition } from '../types'

@Component({ components: { DataTable } })
export default class DataTableGroup extends Vue {
  @Prop() data!: TableGroupDefinition
}
